import * as Environment from "../base/Environment.js";

import {Stage, AnimatableSprite} from "../base/Display2D.js";
import {LoaderSystem, DataLoaderJob} from "../base/Loader.js";

import {LazyLoader} from "../components/LazyLoader.js";

import {SiteSection} from "./SiteSection.js";
export {SiteSection};

import {Navigation} from "./Navigation.js";
import {VideoOverlay, OverlayVideoPlayer} from "./VideoOverlay.js";


//
// Site extends Stage
//

export const Site = function (context) {
	Stage.apply (this, arguments);

	if (Site.sharedInstance)
		throw new Error ("Cannot instantiate. Site is singleton.");

	Site.sharedInstance = this;

	var element = this.element;
	element.classList.remove ("sprite");

	this.createMediaProbes (["mobile"]);
	this.createGridRuler ();

	var sections = this.sections = new Array ();
	this.setUpContent ();

	var lazyLoader = this.lazyLoader = new LazyLoader (element);

	context.resizeDispatcher.addListener ("scroll", this.scroll, this);

	this.addListener ("resize", this.resize, this);
	this.resize ();

	if (Environment.FAST_PASS) {
		/*
		window.setTimeout (function () {

		}.bind (this), 250);
		*/

	}

	if (Environment.IS_IN_NEOS_EDITOR)
		this.addMutationObserver ();

	window.setTimeout (function () {
		this.resize ();

	}.bind (this), 50);

};

Site.prototype = Object.create (Stage.prototype);

Site.prototype.resizeContext = function (context) {
	this.setSize (
		Environment.IS_TOUCH_DEVICE ?
			context.getViewportSize () :
			this.getRulerSize ()

	);

};

Site.prototype.createGridRuler = function () {
	var gridRuler = this.gridRuler = document.createElement ("div");
	gridRuler.classList.add ("grid-ruler");

	var gridContainer = document.createElement ("div");
	gridContainer.classList.add ("container");

	var gridRow = document.createElement ("div");
	gridRow.classList.add ("row");

	var gridColumns = this.gridColumns = new Array ();

	for (var i = 12; i--;) {
		var gridColumn = document.createElement ("div");
		gridColumn.classList.add ("col-1");

		gridColumn.appendChild (document.createElement ("div"));

		gridColumns.push (gridColumn);
		gridRow.appendChild (gridColumn);

	}

	gridContainer.appendChild (gridRow);
	gridRuler.appendChild (gridContainer);

	document.body.appendChild (gridRuler);

};

Site.prototype.setUpContent = function () {
	var element = this.element;
	this.setUpSectionControllers (element);

};

Site.prototype.setUpSectionControllers = function (element) {
	var sectionElements = element.querySelectorAll ("[data-class-name]");
	if (!sectionElements.length)
		sectionElements = [element];

	var sections = this.sections;
	for (var i = sections.length; i--;) {
		var section = sections [i];
		section.isInUse = false;

	}

	for (var i = 0; i < sectionElements.length; i++) {
		var sectionElement = sectionElements [i];
		var section = sectionElement.section;

		if (!section) {
			sectionElement.setAttribute ("data-processed", "yes");

			var sectionClassName = sectionElement.getAttribute ("data-class-name");

			section = sectionElement.section = this.attachSprite (window [sectionClassName] || SiteSection);
			section.takeElement (sectionElement);

			sections.push (section);

		}

		section.isInUse = true;

	}

	for (var i = sections.length; i--;) {
		var section = sections [i];
		if (!section.isInUse)
			sections.splice (i, 1);

	}

};

Site.prototype.addMutationObserver = function () {
	var mutationObserver = new MutationObserver (this.mutateElement.bind (this));
	mutationObserver.observe (this.element, {
		childList: true,
		subtree: true

	});

};

Site.prototype.mutateElement = function (mutations) {
	var now = new Date ().getTime ();
	var nextTimeToObserve = this.nextTimeToObserve;

	if (now < nextTimeToObserve) {
		if (!this.mutationHandler) {
			this.mutationHandler = window.setTimeout (
				this.handleMutation.bind (this),
				nextTimeToObserve - now

			);

		}

	} else {
		this.handleMutation ();

	}

};

Site.prototype.handleMutation = function () {
	this.mutationHandler = null;

	var now = new Date ().getTime ();
	var nextTimeToObserve = this.nextTimeToObserve = now + 500;

	// trace ("---- handle mutation ----");

	this.isMutating = true;

	this.setUpContent ();

	var element = this.element;

	this.setUpSectionControllers (element);

	this.resize (this);

	this.dispatchEvent ("mutate");

	this.isMutating = false;

};

Site.prototype.resize = function (sender) {
	var viewportSize = this.size;
	var sections = this.sections;

	for (var i = sections.length; i--;) {
		var section = sections [i];
		section.setViewSize (viewportSize);

	}

	if (sender)
		this.renderInContext ();

	this.scroll ();

};

Site.prototype.scroll = function (sender) {
	var size = this.size;
	var sections = this.sections;

	for (var i = sections.length; i--;) {
		var section = sections [i];
		var sectionElement = section.element;

		var pageBounds = section.pageBounds = sectionElement.getBoundingClientRect ();

		if (pageBounds.height &&
			pageBounds.top < size [1] * 1.25 &&
			pageBounds.bottom > -size [1] * .5) {
			if (!section.didStartLoading) {
				section.startLoading ();

			}

		}

		if (pageBounds.height &&
			pageBounds.top < size [1] + (section.viewOffsetTop || 0) &&
			pageBounds.bottom > 0) {
			if (!section.isAwake)
				section.awake ();

			section.scroll (!sender);

		} else {
			if (section.isAwake)
				section.sleep ();

			continue;

		}

	}

	var lazyLoader = this.lazyLoader;
	lazyLoader.update ();

};

Site.prototype.scrollToOffset = function (targetOffset) {
	var scrollOffset = RenderContext.getScrollOffset () [1];
	var scrollStart = this.scrollStart = scrollOffset;

	if (scrollStart != targetOffset || this.scrollEnd != targetOffset) {
		this.scrollEnd = targetOffset;
		this.isScrolling = true;

		var delta = Math.abs (scrollStart - targetOffset);
		this.startAnimation ("Scroll", {direction: 1, rate: Math.max (
			.01, .1 / 4 / Math.max (
				1, delta / 640

			)

		) * 1.5, phase: 0});

	}

};

Site.prototype.animateScroll = function () {
	var state = this.updatedState ("Scroll");
	var t = 1 - state.phase;
	t = 1 - t * t * t;
	t = .5 - Math.cos (t * Math.PI) / 2;
	var t_ = 1 - t;

	if (Math.abs (this.scrollStart * t_ + this.scrollEnd * t - this.scrollEnd) < 1)
		this.isScrolling = false;

	var scrollTop = Math.round (this.scrollStart * t_ + this.scrollEnd * t);
	window.scroll (0, scrollTop);

};

Site.prototype.openVideoLayerFromSourceElement = function (sourceElement) {
	var videoController = this.videoController;
	if (!videoController) {
		videoController = this.videoController = this.attachSprite (OverlayVideoPlayer);
		document.body.appendChild (videoController.element);

	}

	videoController.startVideoWithSourceElement (sourceElement);

};
